import {lazy} from 'react';

export const SuccessMissionPopup = lazy(() =>
  import('./SuccessMissionPopup.eager').then(mod => ({
    default: mod.SuccessMissionPopup,
  })),
);
